export default class Brand {
    constructor(
        name,
        categoryId,
        image
    ) {
        this.name = name;
        this.categoryId = categoryId;
        this.image = image;
    }
}
